export function insertCommaDelimiter(num: string | number): string {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}
